import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IPrecatorio } from "../interface/precatorio/IPrecatorio";
import { UserTypeEnum } from "../enum/UserTypeEnum";
import { IDapPrecatorioResponse } from "../interface/precatorio/IDapPrecatorioResponse";
import { IPrecatorioUpdateRequet } from "../interface/precatorio/IPrecatorioUpdateRequest";
import { IDapPrecatorioRequest } from "../interface/precatorio/IDapPrecatorioRequest";
import { ITradeOwner } from "../interface/trade/Owner/ITradeOwner";
import { Dayjs } from "dayjs";

enum PrecatorioServiceEnum {
  findDap = "/find-dap",
  getByStatusPending = "/get-precatorios-by-status/Pendente",
  reject = "/rejected-precatorio/",
  editFromWorkflowPricing = "/edit-precatorio-from-workflow-pricing",
  getByStatusPricing = "/get-precatorios-by-status/Precificando",
  getById = "/get-precatorio-by-id/",
  findByRangeDateAndUserType = "/filter-by-date-range-and-user-type-dashboard",
  getPrecatorioUpdateRequest = "/update-request/get",
  updateRequestApprove = "/update-request/approve",
  updateRequestReject = "/update-request/reject",
  updatePrecatorio = "/update-precatorio/",
  shouldPrecatorioPrecify = "/should-precatorio-precify",
  shouldPrecatorioPrecifyInOwner = "/should-precatorio-precify-owner/"
}

export default class PrecatioService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/precatorio");
  }

  public getById = async (id): Promise<IPrecatorio> => await this.GET(PrecatorioServiceEnum.getById + id);
  public getByStatusPending = async (): Promise<IPrecatorio[]> => await this.GET(PrecatorioServiceEnum.getByStatusPending);
  public getByStatusPricing = async (): Promise<IPrecatorio[]> => await this.GET(PrecatorioServiceEnum.getByStatusPricing);

  public postFindDap = async (data: IDapPrecatorioRequest): Promise<IDapPrecatorioResponse> => await this.POST(PrecatorioServiceEnum.findDap, data);
  public reject = async (id, reason): Promise<IPrecatorio[]> => await this.PUT(PrecatorioServiceEnum.reject + `${id}/${reason ? reason : "reason"}`, null);
  public putEditFromWorkflowPricing = async (data: IPrecatorio) => await this.PUT(PrecatorioServiceEnum.editFromWorkflowPricing, data);
  public findByRangeDateAndUserType = async (dateRange: Dayjs[], userType: UserTypeEnum): Promise<IPrecatorio[]> =>
    await this.POST(PrecatorioServiceEnum.findByRangeDateAndUserType, { startDate: dateRange[0], endDate: dateRange[1], userType });
  public getPrecatorioUpdateRequest = async (precatorioId: IPrecatorio["id"]): Promise<IPrecatorio> =>
    await this.GET(`${PrecatorioServiceEnum.getPrecatorioUpdateRequest}/${precatorioId}`);
  public approveUpdateRequest = async (precatorioUpdated: Partial<IPrecatorioUpdateRequet>) => await this.PUT(PrecatorioServiceEnum.updateRequestApprove, precatorioUpdated);
  public rejectUpdateRequest = async (id: IPrecatorio["id"]) => await this.DELETE(PrecatorioServiceEnum.updateRequestReject, { id });
  public updatePrecatorio = async (precatorio: IPrecatorio, tradeId: number) => await this.PUT(PrecatorioServiceEnum.updatePrecatorio + tradeId, precatorio);
  public shouldPrecatorioPrecify = async (precatorio: IPrecatorio): Promise<boolean> => await this.POST(PrecatorioServiceEnum.shouldPrecatorioPrecify, precatorio);
  public shouldPrecatorioPrecifyInOwner = async (precatorioId: number, owner: ITradeOwner): Promise<boolean> => await this.POST(PrecatorioServiceEnum.shouldPrecatorioPrecifyInOwner + precatorioId, owner);
}
